$ = require 'jquery'
h = require './helpers'
Checkbox = require './../components/checkbox'

class PersonalRegistration
  applyStyles: ->
    console.log 'Применяю стили PersonalRegistration'
    $form = $('#aspnetForm')

    $staff = $form.children()

    h.h1('Регистрация туриста', 'h1-personal-registration').appendTo $form
    [$row, $wrapper] = h.rowN(true, 'personal-registration-content')
    $form.append $row

    $staff.appendTo $wrapper

    $('#ctl00_generalContent_personalRegistrationControl_lblPhoneFormatDescription').text('Телефон в формате +79871234567')
    $phone = $('.frontPanel tr').eq(3).find('input')
    $phone.val('+')
    $phone.on('keyup', @onPhoneInput)
    @addPersonalDataCheckbox()

  addPersonalDataCheckbox: () ->
    $personalDataCheckbox = $ '
      <tr>
        <td colspan="3"><input id="personalData" type="checkbox"><label for="personalData"><a target="_blank" href="https://www.tourtrans.ru/files/agreement_pd.pdf">Согласен на обработку моих персональных данных</a></label></td>
      </tr>
    '
    $('.frontPanel tr:eq(17)').before $personalDataCheckbox
    $input = $ '#personalData'
    $label = $ 'label[for=personalData]'
    new Checkbox($input, $label, {trigger_click: false})

    $oldSubmit = $('#ctl00_generalContent_personalRegistrationControl_btnOK')

    $row = $ '<tr><td></td></tr>'
    $newSubmit = $ '<a href="#" class="btn pull-right">Зарегистрироваться</a>'
    $('.frontPanel').append $row
    $row.append $newSubmit
    $newSubmit.click (e) =>
      e.preventDefault()
      if not $input.prop('checked')
        alert('Примите согласие на обработку персональных данных')
      else
        $oldSubmit.click()

  onPhoneInput: (e) =>
    $input = $(e.target)
    phone = $input.val()
    phone = phone.replace(/\D/g, '')
    phone = '+' + phone
    $input.val(phone)

    console.log('input', $input.val(), phone)


module.exports = new PersonalRegistration
